
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vse-budet-horosho",
      function () {
        return require("private-next-pages/vse-budet-horosho.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vse-budet-horosho"])
      });
    }
  